let ENV = 'production';

if (window.location.hostname === 'ai-ml-staging-v1.completumhealth.com') {
    ENV = 'staging';
} else if (window.location.hostname === 'aiml.completumhealth.com') {
    ENV = 'production';
} else {
    ENV = 'local';
}

console.log(ENV);

const config = {
    local: {
        API_URL: "http://localhost:5000/reporting/biweekly/v1",
        WEEK_ONE_API_URL: process.env.REACT_APP_WEEK_ONE_API_URL || "http://localhost:5000/reporting/weekone/v1", // override when 5000 is taken (macOS AirPlay)
        MEMBERS_API_URL: "https://chatapi-staging-v1.completumhealth.com/reporting/members"
    },
    staging: {
        API_URL: "https://aireporting-staging-v1.completumhealth.com/reporting/biweekly/v1",
        WEEK_ONE_API_URL: "https://aireporting-staging-v1.completumhealth.com/reporting/weekone/v1",
        MEMBERS_API_URL: "https://chatapi-staging-v1.completumhealth.com/reporting/members"
    },
    production: {
        API_URL: "https://aireporting.completumhealth.com/reporting/biweekly/v1",
        WEEK_ONE_API_URL: "https://aireporting.completumhealth.com/reporting/weekone/v1",
        MEMBERS_API_URL: "https://chatapi.completumhealth.com/reporting/members"
    }
};

export const API_URL = config[ENV].API_URL;
export const MEMBERS_API_URL = config[ENV].MEMBERS_API_URL;
export const WEEK_ONE_API_URL = config[ENV].WEEK_ONE_API_URL;
export const IS_LOCAL = ENV === 'local'; 